import resolveConfig from 'tailwindcss/resolveConfig';

import * as config from '../../../../../tailwind.config';

export const tailwindConfig = resolveConfig({
	content: config.content,
	theme: config.theme,
});
